import { useState, useCallback, useRef, useEffect } from "react";

/* ─────────────────────────────────────────────
   CAROUSEL IMAGES — 5 static images
───────────────────────────────────────────── */
import Slide1 from "../../assets/images/behind-the-scenes/bts-1.webp";
import Slide2 from "../../assets/images/behind-the-scenes/bts-2.webp";
import Slide3 from "../../assets/images/behind-the-scenes/bts-3.webp";
import Slide4 from "../../assets/images/behind-the-scenes/bts-4.webp";
import Slide5 from "../../assets/images/behind-the-scenes/bts-5.webp"; 

/* ─────────────────────────────────────────────
   VIDEO THUMBNAILS — replace with actual imports
───────────────────────────────────────────── */
import VThumb1 from "../../assets/images/behind-the-scenes/video-thumb-1.webp";
import VThumb2 from "../../assets/images/behind-the-scenes/video-thumb-2.webp";
import VThumb3 from "../../assets/images/behind-the-scenes/video-thumb-3.webp";
import VThumb4 from "../../assets/images/behind-the-scenes/video-thumb-4.webp";
import VThumb5 from "../../assets/images/behind-the-scenes/video-thumb-5.webp";
import VThumb6 from "../../assets/images/behind-the-scenes/video-thumb-6.webp";
import VThumb7 from "../../assets/images/behind-the-scenes/video-thumb-7.webp";
import VThumb8 from "../../assets/images/behind-the-scenes/video-thumb-8.webp";
import VThumbFeatured from "../../assets/images/behind-the-scenes/video-thumb-featured.webp";

/* ─────────────────────────────────────────────
   PLAY ICON
───────────────────────────────────────────── */
import PlayIconImg from "../../assets/images/behind-the-scenes/play-icon.svg";

/* ─────────────────────────────────────────────
   YOUTUBE VIDEO DATA
   Replace IDs with actual BTS YouTube video IDs
───────────────────────────────────────────── */
const FEATURED_VIDEO = {
  id: "vsPS209P1J8",
  thumb: VThumbFeatured,
};

// 4 rows × 2 = 8 video cards
const BTS_VIDEOS = [
  { id: "2jiHg0VQ7hc", thumb: VThumb1 },
  { id: "gfcqo_r0dU0", thumb: VThumb2 },
  { id: "YgPQ7oWm2Jc", thumb: VThumb3 },
  { id: "P75XXGh9J3Y", thumb: VThumb4 },
  { id: "b07SM8O_Gq4", thumb: VThumb5 },
  { id: "Uq_0u6lwG0g", thumb: VThumb6 },
  { id: "YgPQ7oWm2Jc", thumb: VThumb7 },
  { id: "a3EqWQcyZJo", thumb: VThumb8 },
];

const CAROUSEL_IMAGES = [Slide1, Slide2, Slide3, Slide4, Slide5];

/* ─────────────────────────────────────────────
   CSS
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@300;400;500&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  .bts-page {
    background: #1A1A1A;
    color: #ffffff;
    font-family: 'Roboto', sans-serif;
    min-height: 100vh;
  }

  .bts-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 60px 102px 0 102px;
  }

  /* ════════════════════════════════════════
     FEATURED VIDEO
  ════════════════════════════════════════ */
  .bts-featured {
    position: relative;
    width: 100%;
    border-radius: 10px;
    overflow: hidden;
    background: #1A1A1A;
    height: 500px;
    margin-bottom: 60px;
    opacity: 0;
    transform: translateY(28px);
    transition: opacity 0.55s ease 0.1s, transform 0.55s ease 0.1s;
  }
  .bts-featured.bts-visible { opacity: 1; transform: translateY(0); }
  .bts-featured iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: none;
    display: block;
  }

  /* ════════════════════════════════════════
     THUMBNAIL OVERLAY
  ════════════════════════════════════════ */
  .bts-thumb-overlay {
    position: absolute;
    inset: 0;
    cursor: pointer;
    z-index: 2;
    transition: opacity 0.3s ease;
  }
  .bts-thumb-overlay img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .bts-thumb-overlay.bts-hidden { opacity: 0; pointer-events: none; }

  /* ── Play button ── */
  .bts-play-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 68px;
    height: 68px;
    
    
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  
    transition: background 0.2s ease, transform 0.2s ease;
    z-index: 3;
    pointer-events: none;
  }
  .bts-thumb-overlay:hover .bts-play-btn {
    
    transform: translate(-50%, -50%) scale(1.1);
  }
  .bts-play-btn img { margin-left: 4px; }

  /* small play btn for cards */
  .bts-card .bts-play-btn {
    width: 60px;
    height: 60px;
  }
  .bts-card .bts-play-btn img {
    width: 64px;
    height: 64px;
    margin-left: 3px;
  }

  /* ════════════════════════════════════════
     STATIC IMAGE CAROUSEL
  ════════════════════════════════════════ */
  .bts-carousel-outer {
    margin-bottom: 8px;
    opacity: 0;
    transform: translateY(28px);
    transition: opacity 0.55s ease 0.18s, transform 0.55s ease 0.18s;
    user-select: none;
  }
  .bts-carousel-outer.bts-visible { opacity: 1; transform: translateY(0); }

  .bts-carousel-viewport {
    overflow: hidden;
    border-radius: 12px;
    cursor: grab;
  }
  .bts-carousel-viewport.bts-dragging { cursor: grabbing; }

  .bts-carousel-track {
    display: flex;
    will-change: transform;
  }
  .bts-carousel-track.bts-animated {
    transition: transform 0.45s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .bts-carousel-slide {
    flex: 0 0 calc(100% / 3);
    padding-right: 30px;
  }
  .bts-carousel-slide:last-child { padding-right: 0; }
  .bts-carousel-slide img {
    width: 100%;
    aspect-ratio: 16 / 9;
    height: 250px;
    object-fit: cover;
    border-radius: 10px;
    display: block;
    pointer-events: none;
  }

  /* Dots */
  .bts-dots {
    display: flex;
    justify-content: center;
    gap: 7px;
    margin-bottom: 60px;
    padding-top: 24px;
  }
  .bts-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #3C3C3C;
    cursor: pointer;
    transition: background 0.2s, transform 0.2s;
  }
  .bts-dot:hover { transform: scale(1.2); }
  .bts-dot.bts-dot--active { background: #743FAC; }

  /* ════════════════════════════════════════
     VIDEO ROWS — 4 rows of 2
  ════════════════════════════════════════ */
  .bts-row-2 {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    margin-bottom: 60px;
    opacity: 0;
    transform: translateY(28px);
    transition: opacity 0.55s ease, transform 0.55s ease;
  }
  .bts-row-2.bts-visible { opacity: 1; transform: translateY(0); }
  .bts-row-2.bts-d1 { transition-delay: 0.08s; }
  .bts-row-2.bts-d2 { transition-delay: 0.16s; }
  .bts-row-2.bts-d3 { transition-delay: 0.24s; }
  .bts-row-2.bts-d4 { transition-delay: 0.32s; }

  .bts-card {
    position: relative;
    border-radius: 12px;
    overflow: hidden;
    background: #1A1A1A;
    height: 400px;
  }
  .bts-card iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: none;
    display: block;
  }

  .bts-bottom-space { height: 1px; }

  /* ════════════════════════════════════════
     RESPONSIVE
  ════════════════════════════════════════ */

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .bts-inner { padding: 32px 32px 0 32px;}
    .bts-featured { height: 320px;margin-bottom: 40px; }
    .bts-card { height: 220px; }
.bts-carousel-slide { padding-right:20px;}
    .bts-carousel-slide img { height: 160px; }
    .bts-row-2 { gap: 24px; margin-bottom: 40px; }
    .bts-dots { padding-top: 18px;margin-bottom: 40px;}
  }
    .bts-card .bts-play-btn img{width: 44px;height: 44px;}
    

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .bts-inner { padding-left: 16px; padding-right: 16px; }
    .bts-featured { height: 200px; margin-bottom: 40px; }
    .bts-card { height: 200px; }
    .bts-carousel-slide { flex: 0 0 100%; padding-right: 0; }
    .bts-carousel-slide img { height: 200px; }
    .bts-row-2 { grid-template-columns: 1fr; gap: 30px; margin-bottom: 30px; }
    .bts-play-btn { width: 52px; height: 52px; }
    .bts-dots { margin-bottom: 30px; }
    .bts-card .bts-play-btn img{width: 32px;height: 32px;}

  }
`;

/* ─────────────────────────────────────────────
   VIDEO CARD
───────────────────────────────────────────── */
function VideoCard({ videoId, thumb, activeId, onPlay, isFeatured = false }) {
  const isPlaying = activeId === videoId;

  const handleClick = useCallback(() => {
    onPlay(videoId);
  }, [videoId, onPlay]);

  return (
    <div className={isFeatured ? "bts-featured bts-visible" : "bts-card"}>
      <iframe
        src={
          isPlaying
            ? `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`
            : `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`
        }
        title={`Behind the Scenes ${videoId}`}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
      <div
        className={`bts-thumb-overlay${isPlaying ? " bts-hidden" : ""}`}
        onClick={handleClick}
      >
        <img src={thumb} alt="Video thumbnail" />
        <div className="bts-play-btn">
          <img src={PlayIconImg} alt="Play" />
        </div>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   AUTOPLAY + DRAGGABLE IMAGE CAROUSEL
───────────────────────────────────────────── */
function ImageCarousel({ images }) {
  const VISIBLE = 3;
  const maxIndex = images.length - VISIBLE; // 2 on desktop
  const dotCount = maxIndex + 1;            // 3 dots

  const [current, setCurrent] = useState(0);
  const [animated, setAnimated] = useState(true);
  const [dragging, setDragging] = useState(false);

  const dragStart = useRef(null);
  const dragDelta = useRef(0);
  const trackRef = useRef(null);
  const autoRef = useRef(null);

  // Per-slide width in percent
  const slideW = 100 / VISIBLE;
  const translateX = current * slideW;

  /* ── Autoplay ── */
  const startAuto = useCallback(() => {
    clearInterval(autoRef.current);
    autoRef.current = setInterval(() => {
      setCurrent((c) => (c >= maxIndex ? 0 : c + 1));
      setAnimated(true);
    }, 3500);
  }, [maxIndex]);

  useEffect(() => {
    startAuto();
    return () => clearInterval(autoRef.current);
  }, [startAuto]);

  const goTo = (i) => {
    const clamped = Math.max(0, Math.min(i, maxIndex));
    setCurrent(clamped);
    setAnimated(true);
    startAuto(); // reset timer on manual interaction
  };

  /* ── Drag / pointer events ── */
  const onPointerDown = (e) => {
    dragStart.current = e.clientX ?? e.touches?.[0]?.clientX;
    dragDelta.current = 0;
    setDragging(true);
    setAnimated(false);
    clearInterval(autoRef.current);
  };

  const onPointerMove = (e) => {
    if (dragStart.current === null) return;
    const x = e.clientX ?? e.touches?.[0]?.clientX;
    dragDelta.current = x - dragStart.current;

    // Live drag feedback via inline style on track
    if (trackRef.current) {
      const pxPerSlide = trackRef.current.offsetWidth / VISIBLE;
      const dragPercent = (dragDelta.current / trackRef.current.offsetWidth) * 100;
      trackRef.current.style.transform = `translateX(calc(-${translateX}% + ${dragDelta.current}px))`;
    }
  };

  const onPointerUp = () => {
    if (dragStart.current === null) return;
    const threshold = 60; // px
    if (dragDelta.current < -threshold) {
      goTo(current + 1);
    } else if (dragDelta.current > threshold) {
      goTo(current - 1);
    } else {
      goTo(current); // snap back
    }
    // Reset track inline style — CSS transition takes over
    if (trackRef.current) trackRef.current.style.transform = "";
    dragStart.current = null;
    setDragging(false);
    setAnimated(true);
  };

  return (
    <>
      <div className="bts-carousel-outer bts-visible">
        <div
          className={`bts-carousel-viewport${dragging ? " bts-dragging" : ""}`}
          onMouseDown={onPointerDown}
          onMouseMove={onPointerMove}
          onMouseUp={onPointerUp}
          onMouseLeave={onPointerUp}
          onTouchStart={onPointerDown}
          onTouchMove={onPointerMove}
          onTouchEnd={onPointerUp}
        >
          <div
            ref={trackRef}
            className={`bts-carousel-track${animated ? " bts-animated" : ""}`}
            style={{ transform: `translateX(-${translateX}%)` }}
          >
            {images.map((src, i) => (
              <div className="bts-carousel-slide" key={i}>
                <img src={src} alt={`Behind the scenes ${i + 1}`} draggable={false} />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Dots */}
      <div className="bts-dots">
        {Array.from({ length: dotCount }).map((_, i) => (
          <div
            key={i}
            className={`bts-dot${current === i ? " bts-dot--active" : ""}`}
            onClick={() => goTo(i)}
          />
        ))}
      </div>
    </>
  );
}

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function BehindTheScenes() {
  const [activeId, setActiveId] = useState(null);

  const handlePlay = useCallback((id) => {
    setActiveId(id);
  }, []);

  const row1 = BTS_VIDEOS.slice(0, 2);
  const row2 = BTS_VIDEOS.slice(2, 4);
  const row3 = BTS_VIDEOS.slice(4, 6);
  const row4 = BTS_VIDEOS.slice(6, 8);

  return (
    <>
      <style>{CSS}</style>
      <div className="bts-page">
        <div className="bts-inner">

          {/* Featured video */}
          <VideoCard
            videoId={FEATURED_VIDEO.id}
            thumb={FEATURED_VIDEO.thumb}
            activeId={activeId}
            onPlay={handlePlay}
            isFeatured
          />

          {/* Autoplay draggable image carousel */}
          <ImageCarousel images={CAROUSEL_IMAGES} />

          {/* 4 video rows */}
          <div className="bts-row-2 bts-d1 bts-visible">
            {row1.map((v) => (
              <VideoCard key={v.id} videoId={v.id} thumb={v.thumb} activeId={activeId} onPlay={handlePlay} />
            ))}
          </div>

          <div className="bts-row-2 bts-d2 bts-visible">
            {row2.map((v) => (
              <VideoCard key={v.id} videoId={v.id} thumb={v.thumb} activeId={activeId} onPlay={handlePlay} />
            ))}
          </div>

          <div className="bts-row-2 bts-d3 bts-visible">
            {row3.map((v) => (
              <VideoCard key={v.id} videoId={v.id} thumb={v.thumb} activeId={activeId} onPlay={handlePlay} />
            ))}
          </div>

          <div className="bts-row-2 bts-d4 bts-visible">
            {row4.map((v) => (
              <VideoCard key={v.id} videoId={v.id} thumb={v.thumb} activeId={activeId} onPlay={handlePlay} />
            ))}
          </div>

          <div className="bts-bottom-space" />
        </div>
      </div>
    </>
  );
}